<template>
	<div id="step5" class="sscw-container sscw-flex-column">
		<h2 id="top" class="sscw-step-title">
			{{ wizardContent.step2_header ? wizardContent.step2_header : "step2_header" }}
		</h2>
		<h3 class="step-description">
			{{ wizardContent.step2_Description ? wizardContent.step2_Description : "step2_Description" }}
		</h3>
		<div class="sscw-step-image-group">
			<div class="sscw-mobile-hidden desktop-icon">
				<img :src="theme.selfInformationIcon" width="42px" alt="icon" />
			</div>
			<div class="sscw-step-input-group">
				<div class="mobile-img sscw-desktop-hidden">
					<img :src="theme.selfInformationIcon" width="42px" alt="icon" />
				</div>

				<div class="w-full">
					<div class="sscw-container">
						<div class="">
							<div class="sscw-step6-label">
								<div>
									{{
										wizardContent.step2_address_label
											? wizardContent.step2_address_label
											: "step2_address_label"
									}}
								</div>
							</div>
							<div class="sscw-step-input-box sscw-mb-10" :class="{ 'has-error': addressInvalid }">
								<input
									@blur="validateStep"
									type="text"
									class="sscw-input"
									name="address"
									id="sscw-address"
									:placeholder="
										wizardContent.step2_address_placeholder
											? wizardContent.step2_address_placeholder
											: 'step2_address_placeholder'
									"
									v-model="address"
								/>
							</div>
						</div>
					</div>

					<div class="desktop-row">
						<div class="sscw-container">
							<div>
								<div class="sscw-step6-label">
									<div>
										{{
											wizardContent.step2_zipCode_label
												? wizardContent.step2_zipCode_label
												: "step2_zipCode_label"
										}}
									</div>
								</div>
								<div class="sscw-step-input-box sscw-mb-10" :class="{ 'has-error': zipCodeInvalid }">
									<input
										@blur="validateStep"
										pattern="\d*"
										type="text"
										class="sscw-input"
										name="zipCode"
										id="sscw-zipCode"
										:placeholder="
											wizardContent.step2_zipCode_placeholder
												? wizardContent.step2_zipCode_placeholder
												: 'step2_zipCode_placeholder'
										"
										v-model="zipCode"
									/>
								</div>
							</div>
						</div>

						<div class="sscw-container">
							<div class="">
								<div class="sscw-step6-label">
									<div>
										{{
											wizardContent.step2_state_label
												? wizardContent.step2_state_label
												: "step2_state_label"
										}}
									</div>
								</div>
								<div class="sscw-step-input-box sscw-mb-10" :class="{ 'has-error': stateInvalid }">
									<input
										@blur="validateStep"
										type="text"
										class="sscw-input"
										name="state"
										id="sscw-state"
										v-model="state"
										:placeholder="
											wizardContent.step2_state_placeholder
												? wizardContent.step2_state_placeholder
												: 'step2_state_placeholder'
										"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import displayInEuro from "@/utils/displayInEuro";
import getTheme from "@/utils/theme";
import wizardContent from "@/utils/extnWizardContent";

const IS_ADDRESS_REQUIRED = true;
const IS_ZIPCODE_REQUIRED = true;
const IS_STATE_REQUIRED = true;
export default {
	name: "ClickWizardStep2",
	data() {
		return {
			theme: getTheme(),
			wizardContent: wizardContent(),
			addressInvalid: false,
			zipCodeInvalid: false,
			stateInvalid: false,
		};
	},
	methods: {
		displayInEuro,
		displayInCurrency: (v) => `${("" + v).replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`,
		emitUpdate() {
			this.$emit("updated", {
				address: this.address,
				zipCode: this.zipCode,
				state: this.state,
			});
		},
		checkField(fields, flag, condition) {
			if (flag && condition) {
				fields.push(false);
			}
		},
		checkValidation() {
			const invalidFields = [];

			this.checkField(invalidFields, IS_ADDRESS_REQUIRED, !this.address);
			this.checkField(invalidFields, IS_ZIPCODE_REQUIRED, !this.zipCode);
			this.checkField(invalidFields, IS_STATE_REQUIRED, !this.state);

			// if (invalidFields.length === 0) {
			// 	return false;
			// }

			// const isValid = (isInvalid) => !isInvalid;
			// return invalidFields.every(isValid);
			return true
		},
		validateForm() {
			const invalidFields = [];

			if (IS_ADDRESS_REQUIRED) {
				this.addressInvalid = !this.address;
				invalidFields.push(this.addressInvalid);
			}

			if (IS_ZIPCODE_REQUIRED) {
				this.zipCodeInvalid = !this.zipCode;
				invalidFields.push(this.zipCodeInvalid);
			}

			if (IS_STATE_REQUIRED) {
				this.stateInvalid = !this.state;
				invalidFields.push(this.stateInvalid);
			}

			const isValid = (isInvalid) => !isInvalid;
			const isAllValid = invalidFields.every(isValid);
			this.$store.isCurrentStepValid = isAllValid;
			// return isAllValid;
			return true;
		},
		validateStep() {
			return true
		},
	},
	computed: {
		wizardState() {
			return this.$store.wizardState;
		},
		address: {
			get() {
				return this.$store.wizardState.address;
			},
			set(value) {
				this.$store.wizardState.address = value;
			},
		},
		zipCode: {
			get() {
				return this.$store.wizardState.zipCode;
			},
			set(value) {
				this.$store.wizardState.zipCode = value;
			},
		},
		state: {
			get() {
				return this.$store.wizardState.state;
			},
			set(value) {
				this.$store.wizardState.state = value;
			},
		},
	},
	mounted() {
		this.emitUpdate();
		this.$store.isCurrentStepValid = true;
		if (!this.checkValidation()) {
			this.$store.isCurrentStepValid = true;
		}
		this.$nextTick(() => {
			document
				.querySelector("#shortcode-2-977 > ss-lebenswert-wizard-extn")
				?.shadowRoot.querySelector("#top")
				?.scrollIntoView();
			window.scrollTo(0, -150);
		});
	},
};
</script>

<style scoped>
.sscw-step-input-group {
	display: flex;
	flex-direction: row;
}

.w-full {
	width: 100%;
}

.mobile-img {
	align-self: flex-start;
	margin-left: 14px;
}

.sscw-step6-label {
	font-family: Inter;
	font-size: 16px;
	font-weight: 500;
	line-height: 24px;
	letter-spacing: 0em;
	text-align: left;
}

.sscw-step-image-group {
	margin-bottom: 20px;
	display: flex;
	gap: 34px;
	align-items: center;
}

@media (min-width: 1190px) {
	.desktop-row {
		display: flex;
		gap: 12px;
		padding: 0 32px;
	}

	.sscw-step-input-group {
		width: 686px;
	}

	.sscw-step6-label {
		font-size: 18px;
		line-height: 20px;
	}
}
</style>
